var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticStyle:{"text-align":"left","padding-left":"20px"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('md-toolbar',[_vm._t("actions",null,{"actionStyle":"margin-right: 15px"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }